var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatePickerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 18C14.9941 18 15.75 17.2441 15.75 16.3125V3.93749C15.75 3.00585 14.9941 2.24999 14.0625 2.24999H12.375V0.281249C12.375 0.126548 12.2484 0 12.0937 0H11.5312C11.3765 0 11.25 0.126548 11.25 0.281249V2.24999H4.49999V0.281249C4.49999 0.126548 4.37344 0 4.21874 0H3.65624C3.50154 0 3.37499 0.126548 3.37499 0.281249V2.24999H1.6875C0.755857 2.24999 0 3.00585 0 3.93749V16.3125C0 17.2441 0.755857 18 1.6875 18H14.0625Z",
    fill: "#1752AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 5.62499H1.125V3.9375C1.125 3.62813 1.37813 3.375 1.6875 3.375H14.0625C14.3718 3.375 14.625 3.62813 14.625 3.9375V5.62499Z",
    fill: "#FEFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 16.875H1.6875C1.37813 16.875 1.125 16.6218 1.125 16.3125V6.75H14.625V16.3125C14.625 16.6218 14.3718 16.875 14.0625 16.875Z",
    fill: "#FEFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/DatePickerIcon.c0cfae869f076ba7a7e5daea2a66c94d.svg";
export { ForwardRef as ReactComponent };